import logoLight from "../../assets/images/logoLight.svg";
import { FaWhatsapp } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { SITE } from "../../constants/site";
import { isRtlLanguage } from "../../utils/i18n";
import {
  LANDING_WHATSAPP_CONTEXT,
  resolveLandingWhatsAppCta,
} from "../../utils/landingWhatsapp";
import "../layout/NavBar.css";
import "./LandingLogoNav.css";

function LandingLogoNav() {
  const { t, i18n } = useTranslation();
  const isRtl = isRtlLanguage(i18n.language);
  const whatsappLink = resolveLandingWhatsAppCta(t, LANDING_WHATSAPP_CONTEXT.NAV);
  const contactLink = resolveLandingWhatsAppCta(t, LANDING_WHATSAPP_CONTEXT.CONTACT);

  return (
    <header id="nav" className="caf-site-nav landing-logo-nav" dir={isRtl ? "rtl" : "ltr"}>
      <div className="landing-logo-nav__inner">
        <img src={logoLight} alt={SITE.name} className="caf-site-nav__logo landing-logo-nav__logo" />

        <div className="landing-logo-nav__actions">
          <a
            href={whatsappLink.href}
            className="landing-logo-nav__action landing-logo-nav__action--whatsapp"
            target={whatsappLink.target}
            rel={whatsappLink.rel}
          >
            <FaWhatsapp aria-hidden="true" />
            <span className="landing-logo-nav__action-label">{t("WhatsApp")}</span>
          </a>
          <a
            href={contactLink.href}
            className="landing-logo-nav__action landing-logo-nav__action--contact"
            target={contactLink.target}
            rel={contactLink.rel}
          >
            {t("Contact Us")}
          </a>
        </div>
      </div>
    </header>
  );
}

export default LandingLogoNav;
